'use strict';
/* ==========================================================================
   levels/title.js — title screen: blueprint sky, a paper coaster looping
   the loop forever (the honest c5 track from core-local/tracks.js), Max and
   Dr. Voss on either side, ransom title, big ▶ Play → the map.
   Levels.title.loading() draws the "cutting paper…" screen used by Game
   while assets load (no paper textures exist yet, so plain fills + ink only).
   ========================================================================== */
(function () {
  const PLAY = { x: 960, y: 560 };

  /* blueprint sky: the tex_blueprint scan if we have it, else navy paper + a drawn grid */
  function blueprint(seed = 7) {
    if (IMG.tex_blueprint) { g.drawImage(IMG.tex_blueprint, 0, 0, Game.W, Game.H); return; }
    g.fillStyle = paperTile('#2f5f8f', seed); g.fillRect(0, 0, Game.W, Game.H);
    g.save(); g.strokeStyle = 'rgba(220,235,255,0.16)'; g.lineWidth = 1.2; g.beginPath();
    for (let x = 0; x <= Game.W; x += 48) { g.moveTo(x, 0); g.lineTo(x, Game.H); }
    for (let y = 0; y <= Game.H; y += 48) { g.moveTo(0, y); g.lineTo(Game.W, y); }
    g.stroke(); g.lineWidth = 2; g.strokeStyle = 'rgba(220,235,255,0.22)'; g.beginPath();
    for (let x = 0; x <= Game.W; x += 240) { g.moveTo(x, 0); g.lineTo(x, Game.H); }
    for (let y = 0; y <= Game.H; y += 240) { g.moveTo(0, y); g.lineTo(Game.W, y); }
    g.stroke(); g.restore();
  }
  function ground(y = 985) {
    paperRect(960, y + 60, 2000, 170, PAL.kraft, { seed: 12, torn: true, depth: 1.4, tex: 'tex_kraft', boil: false });
  }

  class Title extends Scene {
    enter() { this.started = false; this.R = Tracks.get('c5_honest'); }

    go() {
      if (this.started) return;
      this.started = true;
      Audio.unlock();
      Audio.music(Game.MUSIC, { gain: 0.3 });
      Game.replace(new Levels.map());
    }
    keyDown(k) { if (k === 'Enter' || k === ' ') this.go(); }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t = this.t, t0 = this.enteredAt;
      blueprint();
      if (IMG.fairground) cut('fairground', 1500, 960, 520, { ay: 1, alpha: 0.35, depth: 0, seed: 3 });
      // the coaster: loop the honest loop track forever (rest a beat in the station, then go again)
      const R = this.R, sim = R.sim, cyc = sim.tSettle + 1.2, st = sim.sample(Math.max(0, (t - 0.8) % cyc));
      const vw = Coaster.view(330, 948, 12.5);
      Coaster.drawTrack(R.track, vw, { seed: 3, prog: E.outCubic(P(T, t0 + 0.1, t0 + 1.1)), postEvery: 3 });
      if (t > 1) Coaster.drawCart(R.track, vw, st.s, { h: 58, seed: 5 });
      if (st.speed > 12) speedLines(vw.X(st.x) - 30, vw.Y(st.y) - 30, Math.cos(st.angle), -Math.sin(st.angle), 60, 40, 3, 90 + BF % 3, 0.6);
      ground();
      tape(120, 40, 170, -0.5, undefined, 2); tape(1800, 40, 170, 0.5, undefined, 3);

      // title
      ransom('ENERGY', 960, 200, 150, t0 + 0.4, { seed: 101 });
      hand('the big drop', 1000, 345, 96, t0 + 1.0, { dur: 0.45, color: PAL.cream, rot: -0.03, outline: 'rgba(37,60,90,0.9)' });
      ink([[760, 400], [960, 392], [1200, 402]], { w: 6, seed: 19, prog: P(T, t0 + 1.4, t0 + 1.65), color: PAL.mustard });

      // the cast
      const rise = n => E.outBack(P(T, t0 + n, t0 + n + 0.5), 1.4);
      Puppet.draw('max', 190, 1080 + (1 - rise(0.7)) * 500, 560, { facing: 1, t: T, pose: 'cross' });
      Puppet.draw('voss', 1720, 1080 + (1 - rise(0.9)) * 500, 600, { facing: -1, t: T });

      // portrait phone: the title's controls are in the dock (core/dock.js Dock.title); the stage keeps the art
      if (UI.docked()) { Dock.title({ onStart: () => this.go() }); return; }
      if (t > 1.4 && UI.button('play', '▶ Play', PLAY.x, PLAY.y, { w: 420, h: 136, color: PAL.red, font: "'Luckiest Guy'", size: 70, rot: -0.02 })) this.go();
      if (t > 2.4) hand('a roller-coaster lesson about energy', 960, 680 + (UI.tap(136) - 136) / 2, UI.text(40), t0 + 2.4, { color: PAL.cream, seed: 61, outline: 'rgba(37,60,90,0.8)' });
    }
  }
  Title.PLAY = PLAY;
  Title.blueprint = blueprint;
  Title.ground = ground;

  /* loading screen: no textures yet → plain paper colour, ink scissors snipping along a dashed line */
  Title.loading = function () {
    g.fillStyle = PAL.paper; g.fillRect(0, 0, Game.W, Game.H);
    const cx = 960, cy = 470, x0 = 620, x1 = 1300;
    const prog = (T * 0.35) % 1, sx = lerp(x0, x1, prog);
    for (let x = x0; x < x1; x += 34) ink([[x, cy + 60], [x + 18, cy + 60]], { w: 4, seed: x, alpha: x < sx ? 0.25 : 0.8, passes: 1, step: 20 });
    const open = 0.28 + Math.sin(T * 12) * 0.22;
    g.save(); g.translate(sx, cy + 60);
    [-1, 1].forEach(side => {
      g.save(); g.rotate(side * open);
      ink([[0, 0], [120, -6 * side], [150, 0]], { w: 7, seed: 70 + side, color: PAL.ink, step: 12 });
      ink([[0, 0], [-60, 18 * side]], { w: 7, seed: 72 + side, step: 12 });
      inkCircle(-86, 28 * side, 26, { w: 6, seed: 74 + side, color: side > 0 ? PAL.red : PAL.navy });
      g.restore();
    });
    g.restore();
    hand('cutting paper…', cx, cy + 190, 84, 0, { dur: 0.01, seed: 5 });
  };

  Levels.title = Title;
})();
